<template lang="pug">
  .durometer
    h4 {{ __('Durometer Rating', 'specs') }}
    .line
      .rating(:style='{ left: ratingPosition }') {{ rating }}
      .tick
        .v 65
      .tick
        .v 70
      .tick
        .v 75
      .tick
        .v 80
      .tick
        .v 85
      .tick
        .v 90
      .tick
        .v 95
      .tick
        .v 100
    .gradient
    .text
      b {{ __('SOFTER = MORE BOUNCE', 'specs') }}
      b {{ __('HARDER = LESS BOUNCE', 'specs') }}
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'

const props = defineProps({
  rating: {
    type    : [Number, String] as PropType<number | string>,
    default : 83,
  },
})

const ratingPosition = computed(() => {
  const min = 65
  const max = 100
  const value = Number(props.rating)
  
  return `${((value - min) / (max - min)) * 100}%`
})
</script>

<style lang='scss' scoped>
  .durometer {
    margin-left: auto;
    margin-right: auto;
    padding: $space-s;
  }

  .line {
    width: calc(100% - 2px);
    height: 30px;
    border-top: $border-width-thick solid $color-black;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 44px;
  }

  .rating {
    position: absolute;
    padding: 4px;
    background-color: $color-red;
    border-radius: 50%;
    color: $color-white;
    font-weight: bold;
    top: -44px;
    transform: translateX(-50%);

    &:after {
      content: '↓';
      color: $color-red;
      position: absolute;
      left: 50%;
      top: 100%;
      font-size: 20px;
      font-weight: bold;
      transform: translate(-50%, -50%);
    }
  }

  .tick {
    width: $border-width-thick;
    height: 10px;
    background-color: $color-black;
    position: relative;
    margin-top: -1px;
  }

  .v {
    position: absolute;
    top: 100%;
    left: -10px;
    width: 24px;
    text-align: center;
    font-weight: bold;
  }

  .text {
    display: flex;
    justify-content: space-between;
  }

  .gradient {
    width: 100%;
    height: 24px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url(../../../assets/durometer.svg);
  }
</style>
